/* ============================================================================
   ATELIER — deterministic star ratings
   Rating (4 | 4.5 | 5) and review count (100–312) are derived from a stable
   hash of the product handle, so a product ALWAYS shows the same values.
   Renders SVG stars (half via linearGradient); empty stars keep the .at-star
   base class so they never render at the default (huge) size.
   Exposes window.AtRatings for reuse (e.g. product reviews section).
   ========================================================================== */
(function () {
  var PATH = 'M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.1l-4.95 2.6.94-5.5-4-3.9 5.53-.8z';
  var uidCounter = 0;

  // FNV-1a style 32-bit hash — deterministic across loads.
  function hash(str) {
    str = String(str);
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h >>> 0;
  }

  function ratingFor(handle) {
    var opts = [4, 4.5, 5];
    return opts[hash(handle) % 3];
  }

  // Count is server-rendered by the shared at-rating-data source (30..90).
  function countFor(handle, renderedCount) {
    var count = Number(renderedCount);
    return count >= 30 && count <= 90 ? count : 30;
  }

  function star(kind, uid, i) {
    if (kind === 'full') {
      return '<svg class="at-star at-star--full" viewBox="0 0 20 20" aria-hidden="true"><path fill="var(--at-star)" d="' + PATH + '"/></svg>';
    }
    if (kind === 'empty') {
      return '<svg class="at-star at-star--empty" viewBox="0 0 20 20" aria-hidden="true"><path fill="var(--at-star-empty)" d="' + PATH + '"/></svg>';
    }
    var id = 'atstar-' + uid + '-' + i;
    return '<svg class="at-star at-star--half" viewBox="0 0 20 20" aria-hidden="true">' +
      '<defs><linearGradient id="' + id + '"><stop offset="50%" stop-color="var(--at-star)"/><stop offset="50%" stop-color="var(--at-star-empty)"/></linearGradient></defs>' +
      '<path fill="url(#' + id + ')" d="' + PATH + '"/></svg>';
  }

  function starsHTML(rating, sizeClass) {
    var uid = 'j' + (uidCounter++);
    var full = Math.floor(rating);
    var half = (rating - full) >= 0.5;
    var out = '<span class="at-stars' + (sizeClass || '') + '" role="img" aria-label="Rated ' + rating + ' out of 5">';
    for (var i = 1; i <= 5; i++) {
      if (i <= full) out += star('full', uid, i);
      else if (i === full + 1 && half) out += star('half', uid, i);
      else out += star('empty', uid, i);
    }
    return out + '</span>';
  }

  function fill(el) {
    var handle = el.getAttribute('data-at-handle');
    if (!handle) return;
    var rating = ratingFor(handle);
    var count = countFor(handle, el.getAttribute('data-at-review-count'));
    var size = el.getAttribute('data-at-size');
    var sizeClass = size === 'sm' ? ' at-stars--sm' : (size === 'lg' ? ' at-stars--lg' : '');
    var html = starsHTML(rating, sizeClass);
    if (el.getAttribute('data-at-number') === 'true') html += '<span class="at-stars__num">' + rating + '</span>';
    if (el.getAttribute('data-at-count') === 'true') html += '<span class="at-stars__count">(' + count + ')</span>';
    el.innerHTML = html;
    el.setAttribute('data-rating', rating);
    el.setAttribute('data-count', count);
  }

  function run(root) {
    (root || document).querySelectorAll('[data-at-rating]').forEach(function (el) {
      if (!el.__atDone) { el.__atDone = true; fill(el); }
    });
  }

  window.AtRatings = { hash: hash, ratingFor: ratingFor, countFor: countFor, starsHTML: starsHTML, run: run };

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', function () { run(); });
})();
